import React from "react";
import ProductScreen from "../../components/ProductScreen";

export default function AIAgents() {
  return (
    <ProductScreen
      heroImageSrc="/product-heroes/ai.png"
      eyebrow="Products / AI Agents"
      title="AI Agents"
      accent="#ff2e78"
      description="Autonomous and assisted AI employees for your business."
      bullets={[
        "Assistants, automation, and insights for teams that need scale.",
        "Blend rule-based flows with AI-powered execution.",
        "Support operational work without overwhelming people.",
      ]}
      features={[
        { title: "Assistants", text: "Field routine questions and actions with smart support." },
        { title: "Automation", text: "Turn repeatable work into dependable flows." },
        { title: "Insights", text: "Surface signals and recommendations from activity." },
      ]}
      ctaLabel="Explore AI Agents"
      summaryKicker="AI Layer"
      summaryTitle="Blend assisted and autonomous work into a practical operating model."
      summaryText="AI Agents helps teams translate repetitive work into intelligent flows that still feel controlled, explainable, and useful."
    />
  );
}
